import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AuthGuard } from '../../../authGuard/auth.guard';
import { EvaluationFormExecutionComponent } from '../evaluation-form-execution/evaluation-form-execution.component';
import { BoardEvaluationExecutionService } from '../../../services/boardEvaluationExecution.service';
import { CategorySidebarComponent } from './category-sidebar/category-sidebar.component';
import { ViewOverallQuestionsComponent } from './view-overall-questions/view-overall-questions.component';
import { ViewQuestionComponent } from './view-question/view-question.component';
import { RiskEvaluationFormExecutionComponent } from '../../risk-evaluation/risk-evaluation-form-execution/risk-evaluation-form-execution.component';
import { RiskCategorySidebarComponent } from '../../risk-evaluation/risk-evaluation-form-execution/risk-category-sidebar/risk-category-sidebar.component';
import { RiskViewOverallQuestionsComponent } from '../../risk-evaluation/risk-evaluation-form-execution/risk-view-overall-questions/risk-view-overall-questions.component';
import { RiskViewQuestionComponent } from '../../risk-evaluation/risk-evaluation-form-execution/risk-view-question/risk-view-question.component';


export const routes: Routes = [
  {
    path: 'evaluationFormExecution/:assignedFormId',
    canActivate: [AuthGuard],
    component: EvaluationFormExecutionComponent,
    outlet: 'structure-outlet',
  },
  {
    path: 'evaluationFormExecution',
    canActivate: [AuthGuard],
    component: EvaluationFormExecutionComponent,
    outlet: 'structure-outlet',
  },

];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    RouterModule.forChild(routes),
  ],
  declarations: [
    EvaluationFormExecutionComponent,
    ViewQuestionComponent,
    ViewOverallQuestionsComponent,
    CategorySidebarComponent,
  ],
  providers: [BoardEvaluationExecutionService],
})
export class EvaluationFormExecutionModule {}
